var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5175_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92039 13.67L7.31039 12.14L5.81039 10.72L7.81039 10.43L10.0604 10.11L10.3504 9.54002H10.3304C10.1009 9.54013 9.8783 9.46127 9.70004 9.3167C9.52178 9.17212 9.39867 8.97062 9.35139 8.74602C9.35039 8.12902 10.1504 8.32902 10.7804 7.28902C10.8604 7.26902 13.6004 -0.000976562 8.00039 -0.000976562C2.40039 -0.000976562 5.14039 7.26902 5.14039 7.26902C5.77039 8.26902 6.58039 8.11902 6.57039 8.71902C6.56039 9.31902 5.83039 9.51902 5.14039 9.58902C4.00039 9.71902 3.00039 9.45902 2.00039 11.349C1.40039 12.439 1.15039 15.999 1.15039 15.999H8.51039V15.829L8.92039 13.67ZM11.7204 16H12.2804L12.0004 15.86L11.7204 16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7303L14.47 16.0003L14 13.3103L16 11.4103L13.24 11.0203L12 8.57031L10.76 11.0203L8 11.4103L10 13.3103L9.53 16.0003L12 14.7303Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5175_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.e61881e60a97a9edbc51b7b7175fc493.svg";
export { ForwardRef as ReactComponent };